import { createActionCreator } from "deox";

export interface ResetPasswordErrorPayload {
  message: string;
  correlationId?: string;
}

export const resetPasswordPending = createActionCreator("resetPasswordPending");
export const resetPasswordSuccess = createActionCreator("resetPasswordSuccess");

export const resetPasswordError = createActionCreator(
  "resetPasswordError",
  (resolve) => (message: string, correlationId?: string) => resolve({ message, correlationId })
);
export const resetPasswordInit = createActionCreator("resetPasswordInit");
